module.exports = __webpack_public_path__ + "static/media/no-data.27e33d8b.svg";